export default "__VITE_ASSET__B3aTGFL3__"